import React, { Fragment } from "react";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { connect } from "react-redux";

import { login } from "../../reducers/account";

import logo from "../../img/loghi/Logo_Home.png";
import Button from "../../component/Button";
import YellowConfirm from "../../component/YellowConfirm";

const styleInput = {
  borderStyle: "solid",
  borderWidth: "1.5px",
  borderRadius: "16px",
  marginTop: "1vh",
  marginBottom: "1vh",
  height: "6vh",
  width: "24vw",
  paddingLeft: 16,
  outline: 0,
};
const loginField = [
  {
    placeholder: "Account",
    target: "identifier",
  },
  {
    placeholder: "Password",
    target: "password",
  },
];
const textAllert = [
  {
    text: "Attenzione",
    fontSize: 32,
    paddingBottom: "3vh",
  },
  {
    text: "Immettere Account e Password di Amministrazione",
    fontSize: 18,
    paddingBottom: "1.6vh",
  },
];
const styleInputBox = {
  borderStyle: "solid",
  marginTop: "1vh",
  marginBottom: "1vh",
  height: "3vh",
  width: "24vw",
  paddingLeft: 16,
  outline: 0,
};

class Login extends React.Component {
  state = {
    openAdministratodDialogue: false,
    identifier: 'gestionale@arboutiqueapartments.it',
    password: 'Demo123!'
  };

  componentDidMount() {
    this.props.login()
  }
  
  componentDidUpdate(oldProps) {
    if (oldProps.user !== this.props.user && !!this.props.user) {
      if (this.state.goToAccountManagement && this.props.user.role.type === 'admingestionale') {
        this.props.history.push("/" + "AccountManagement");
      } else {
        this.props.history.push("/" + "Home");
      }
    }
  }

  _handleChangeInput = (target, value) => {
    this.setState({ [target]: value });
  };

  _handleLogin = () => {
    this.props.login({
      identifier: this.state.identifier,
      password: this.state.password,
    });
  };

  openAdministratorDialogue = () => {
    this.setState({
      openAdministratodDialogue: !this.state.openAdministratodDialogue,
    });
  };

  goToAccountManagement = () => {
    this.setState({
      goToAccountManagement: true,
    })
    this._handleLogin()
  };

  render() {
    // console.log(this.state)
    return (
      <Fragment>
        <div
          style={{
            height: "100vh",
            // width: window.innerWidth,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img src={logo} alt="" style={{ width: "80vw", paddingBottom: "1vh", maxWidth: 760 }} />
          {loginField.map((field) => (
            <input
              type="text"
              style={styleInput}
              placeholder={field.placeholder}
              value={this.state[field.target]}
              onChange={(ev) => this._handleChangeInput(field.target, ev.target.value)}
            />
          ))}
          <button
            style={{
              borderRadius: 16,
              backgroundColor: "white",
              height: "6vh",
              width: "8vw",
              marginTop: "1vh",
              boxShadow: "2px 2px 2px 0px rgba(0,0,0,0.4)",
              outline: 0,
              cursor: "pointer",
            }}
            onClick={this._handleLogin}
          >
            Conferma
          </button>
        </div>
        <div style={{ position: "absolute", top: "6vh", right: "6vh" }}>
          <Button {...this.props} scope={"profile"} goTo={this.openAdministratorDialogue} />
        </div>
        <TransitionGroup>
          <CSSTransition
            classNames={"fade"}
            key={"a"}
            timeout={{ enter: 500, exit: 500 }}
            in={this.state.inProp}
            unmountOnExit={true}
          >
            {this.state.openAdministratodDialogue ? (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  height: window.innerHeight,
                  width: window.innerWidth,
                  backgroundColor: "rgba(0,0,0,0.6)",
                  zIndex: 100,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    backgroundColor: "white",
                    width: "56vw",
                    height: "40vh",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    zIndex: 200,
                  }}
                >
                  {textAllert.map((textAllert) => (
                    <div
                      style={{
                        fontSize: textAllert.fontSize,
                        paddingBottom: textAllert.paddingBottom,
                        paddingLeft: "4vw",
                        paddingRight: "4vw",
                      }}
                    >
                      {textAllert.text}
                    </div>
                  ))}
                  {loginField.map((field) => (
                    <input
                      type="text"
                      value={this.state[field.target]}
                      onChange={(ev) => this._handleChangeInput(field.target, ev.target.value)}
                      style={styleInputBox}
                      placeholder={field.placeholder} />
                  ))}
                  <div style={{ marginTop: "4vh" }}>
                    <YellowConfirm
                      text={"Conferma"}
                      action={this.goToAccountManagement}
                      padding={"1.5vh"}
                      width={"8vw"}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div style={{ display: "none" }}>hidden</div>
            )}
          </CSSTransition>
        </TransitionGroup>
      </Fragment>
    );
  }
}

const mapDispatchToProps = (state) => ({
  user: state.account.data.user,
});

export default connect(mapDispatchToProps, { login })(Login);
